import React__default from "react";
import { Button } from "../../button/button.mjs";
import { Grid } from "../../grid/grid/grid.mjs";
import { GridColumn } from "../../grid/grid-column/grid-column.mjs";
const CarouselGrid = ({ slidesToShow, children, showMoreButton, gridAlignment, align }) => {
  const [open, setOpen] = React__default.useState(false);
  const colWidth = gridAlignment === "center" ? ["lg"] : ["lg-".concat(12 / slidesToShow)];
  const hasOneItem = React__default.Children.count(children) === 1;
  const alignValue = React__default.useMemo(() => {
    if (align === "left") {
      return ["start-xs"];
    }
    if (align === "center") {
      return ["center-xs"];
    }
    if (!hasOneItem) {
      return ["center-xs"];
    }
  }, [align, hasOneItem]);
  const handleButtonClick = React__default.useCallback((event) => {
    event.preventDefault();
    setOpen((prevOpen) => !prevOpen);
  }, []);
  return /* @__PURE__ */ React__default.createElement(Grid, { align: alignValue, equalHeight: true, borderWeight: "thin" }, React__default.Children.map(children, (child, index) => {
    if (React__default.isValidElement(child)) {
      if (!open && showMoreButton && index > 2) {
        return null;
      }
      const colBorder = index === React__default.Children.count(children) - 1 ? void 0 : ["bottom-xs", "bottom-none-lg"];
      return /* @__PURE__ */ React__default.createElement(GridColumn, { width: colWidth, border: colBorder }, child);
    }
  }), !open && showMoreButton && /* @__PURE__ */ React__default.createElement(GridColumn, { width: ["xs"], className: "carousel__show-more" }, /* @__PURE__ */ React__default.createElement(Button, { ...showMoreButton, onClick: handleButtonClick })));
};
export {
  CarouselGrid
};
